import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/domains/pricing")({
  beforeLoad: () => {
    throw redirect({ to: "/hosting/domains/$child", params: { child: "domain-registration" } });
  },
});
